<template>
  <div style="height:100%">
    <!-- <SplitContainer4 style="height:100%" :layout="12" :split_setting1="0.4" :split_height="156">
      <template #top> -->
    <TableMain name="one table" ref="ref_table_test_setting1" :fields="fields" :title="table_title.title1"
      :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
      :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
      :query_button_label="query_lable" :isBusy="isBusy" :loading_width="100" :table_height_adjust="-4"
      :hb_table_class="'hb_table_price_disctable_class1'" @on_query="on_query" @state_change="state_change"
      :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke" @current_changed="current_changed"
      @on_cell_button_click="on_cell_button_click" tableref="a4183c19bc2f42beafa5fcc77ac25efb">
    </TableMain>
    <!-- </template>
<template #center> -->
    <!-- <TableMain name="one table" ref="ref_table_test_setting2" :fields="fields"
      :title="table_title.title1" :show_query_container="false" :show_toolbar_container="false"
      :show_pagination_container="true" :show_date_picker="false" :show_toolbar="false" :show_filter="true"
      :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusy" :loading_width="100"
      :table_height_adjust="1" :hb_table_class="'hb_table_price_disctable_class1'" tableref="baeea16300de47a498ec46c46a0c7453">
    </TableMain> -->
    <!-- </template>
<template #bottom>
        <TableMain name="one table" ref="ref_table_test_setting3" :fields="fields"
          :title="table_title.title1" :show_query_container="false" :show_toolbar_container="false"
          :show_pagination_container="true" :show_date_picker="false" :show_toolbar="false" :show_filter="true"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusy" :loading_width="100"
          :table_height_adjust="8" :hb_table_class="'hb_table_price_disctable_class1'" tableref="b4bab585739b446e86d0c1cd75ded809">
        </TableMain>
      </template>
</SplitContainer4> -->
  </div>
</template>

<script>
import * as PriceDiscTableController from "../controllers/base/PriceDiscTableController"
import BaseContainer from "./components/BaseContainer"
import TestQueryPanel from "./components/base/TestQueryPanel"
import SplitContainer4 from "./components/container/SplitContainer4"
import TableMain from "./components/table/TableMain"

export default {
  name: "TestFieldSetting",
  components: {
    BaseContainer,
    TableMain,
    TestQueryPanel,
    SplitContainer4
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "测试",
      },
      fields: PriceDiscTableController.fields.default,
      dataForm: _.cloneDeep(PriceDiscTableController.dataForm),
      rules: PriceDiscTableController.rules,
      AccountRelation: "",
      SEI_Name: "",
      ItemRelation: "",
      dataAreaId: "",
      isBusy: false,
    }
  },
  created() { },
  methods: {
    async InvokeData() {
      // this.isBusy_table1 = true;
      // this.$refs.CustTable1.SetData([]);
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.in_async"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let _is_wait = true
      setTimeout(() => {
        if (_is_wait) {
          this.msgToasts(this.$t("notify.async_timeout"), "info")
          loading.close()
          _is_wait = false
        }
        return
      }, 1000 * 60 * 5)

      let _params = {
        company: "070",
        tableName: "secp_PriceDiscTable",
        accountNum: "", //不传则查询所有
      }
      await PriceDiscTableController.methods.pickAndInvoke(_params)

      loading.close()
      if (_is_wait) {
        this.msgToasts(this.$t("notify.async_success"), "success")
        _is_wait = false
      }
      this.isBusy = true
      if (isNaN(this._set_data) && isNaN(this._date_range)) {
        this.$refs.CustTable2.SetData([])
        let _params = {
          modifiedDateTime: {
            ">=": this.$date.format(
              new Date().setMonth(new Date().getMonth() - 1),
              "yyyy-MM-dd"
            ),
            "<=": this.$date.format(
              this.$date.addDays(new Date(), 1),
              "yyyy-MM-dd"
            ),
          },
        }
        let _result = await PriceDiscTableController.methods.getData(_params)

        if (!_.isNull(_result) && _result && _result.length > 0) {
          this.$refs.CustTable2.SetData(
            _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
          )
        }
      } else {
        await this.on_query(this._set_data, this._date_range)
      }
      this.isBusy = false
    },
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      let _params = {}
      set_data([])
      _params.dataAreaId = '017'
      let _result = await PriceDiscTableController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.ref_table_test_setting1.SetData(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]))
        // this.$refs.ref_table_test_setting2.SetData(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]))
        // this.$refs.ref_table_test_setting3.SetData(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]))
      }
      this.isBusy = false
    },
    //#endregion

    //#region 保存

    //#endregion

    //#region 状态切换
    // state_change(data, cb) {

    // },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) { },
    //#endregion

    ///cell点击
    on_cell_button_click(data) {

    },

    current_changed(old, current) {

    },
  },
}
</script>

<style>
.hb_table_price_disctable_class1 {
  width: 100vw;
  font-size: 0.8rem;
  background-color: white;
  overflow-x: auto;
  /* min-width: 150rem; */
}
</style>
